/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_Adding_NoteInputs */

const en_mobile_player_adding_note = /** @type {(inputs: Mobile_Player_Adding_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding note…`)
};

const es_mobile_player_adding_note = /** @type {(inputs: Mobile_Player_Adding_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregando nota…`)
};

/**
* | output |
* | --- |
* | "Adding note…" |
*
* @param {Mobile_Player_Adding_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_adding_note = /** @type {((inputs?: Mobile_Player_Adding_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_Adding_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_adding_note(inputs)
	return en_mobile_player_adding_note(inputs)
});